import { DeliverableType, DeliverableUploadedEventAction } from 'types';

export function getDeliverableTrackingActionType(
  type: DeliverableType,
  content: 'url' | 'analytics' | 'high-res'
): DeliverableUploadedEventAction | null {
  if (content === 'analytics' && type.indexOf('post') > -1) {
    return 'post analytics screenshot';
  }

  if (content === 'analytics' && type.indexOf('story') > -1) {
    return 'story analytics screenshot';
  }

  if (content === 'analytics' && type.indexOf('reel') > -1) {
    return 'reel analytics screenshot';
  }

  if (content === 'analytics' && type.indexOf('tiktok') > -1) {
    return 'tiktok analytics screenshot';
  }

  if (content === 'high-res' && type.indexOf('post') > -1) {
    return 'post high-res image';
  }

  if (content === 'high-res' && type.indexOf('story') > -1) {
    return 'story snippet';
  }

  if (content === 'high-res' && type.indexOf('reel') > -1) {
    return 'reel high-res snippet';
  }

  if (content === 'high-res' && type.indexOf('tiktok') > -1) {
    return 'tiktok video';
  }

  if (content === 'high-res' && type.indexOf('other') > -1) {
    return 'other files';
  }

  if (content === 'url' && type.indexOf('post') > -1) {
    return 'post url';
  }

  if (content === 'url' && type.indexOf('reel') > -1) {
    return 'reel url';
  }

  if (content === 'url' && type.indexOf('tiktok') > -1) {
    return 'tiktok video url';
  }

  if (content === 'url' && type.indexOf('blog') > -1) {
    return 'blog url';
  }

  if (content === 'url' && type.indexOf('other') > -1) {
    return 'other url';
  }

  return null;
}
